import { Card, CardContent, Grid } from '@material-ui/core'
import {
  components,
  constants,
  useTranslation
} from 'cng-web-lib'

import DbAdminStatusConfigApiUrls from 'src/apiUrls/DbAdminStatusConfigApiUrls'
import React from 'react'
import DbAdminStatusConfigKeys from 'src/constants/locale/key/DbAdminStatusConfig'
import Namespace from 'src/constants/locale/Namespace'

const {
  card: { CngSimpleCardHeader },
  table: {
    CngCrudTable,
    useDefaultNotification
  }
} = components

const {
  locale: {
    key: { UiComponentKeys }
  }
} = constants

function TablePage(props) {
  const {
    location: { pathname },
    showNotification
  } = props

  const notification = useDefaultNotification(showNotification)
  const { translate } = useTranslation([
    Namespace.UI_COMPONENT,
    Namespace.DB_ADMIN_STATUS_CONFIG
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let dbAdminStatusConfig = translate(
      Namespace.DB_ADMIN_STATUS_CONFIG,
      DbAdminStatusConfigKeys.TITLE
    )
    let tableTitle = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Table.TITLE,
      {
        nameTitleised: dbAdminStatusConfig
      }
    )
    let module = translate(
      Namespace.DB_ADMIN_STATUS_CONFIG,
      DbAdminStatusConfigKeys.MODULE
    )
    let type = translate(
      Namespace.DB_ADMIN_STATUS_CONFIG,
      DbAdminStatusConfigKeys.TYPE
    )
    let tripNumber = translate(
      Namespace.DB_ADMIN_STATUS_CONFIG,
      DbAdminStatusConfigKeys.TRIP_NUMBER
    )
    let shipmentNumber = translate(
      Namespace.DB_ADMIN_STATUS_CONFIG,
      DbAdminStatusConfigKeys.SHIPMENT_NUMBER
    )
    let currentStatus = translate(
      Namespace.DB_ADMIN_STATUS_CONFIG,
      DbAdminStatusConfigKeys.CURRENT_STATUS
    )
    let newStatus = translate(
      Namespace.DB_ADMIN_STATUS_CONFIG,
      DbAdminStatusConfigKeys.NEW_STATUS
    )

    return {
      dbAdminStatusConfig,
      tableTitle,
      module,
      type,
      tripNumber,
      shipmentNumber,
      currentStatus,
      newStatus
    }
  }

  const columns = [
    {
      field: "module",
      title: translatedTextsObject.module,
    },
    {
      field: "type",
      title: translatedTextsObject.type,
    },
    {
      field: "tripNumber",
      title: translatedTextsObject.tripNumber,
    },
    {
      field: "shipmentNumber",
      title: translatedTextsObject.shipmentNumber,
    },
    {
      field: "currentStatus",
      title: translatedTextsObject.currentStatus,
    },
    {
      field: "newStatus",
      title: translatedTextsObject.newStatus,
    }
  ]

  return (
    <Card>
      <CngSimpleCardHeader title={translatedTextsObject.tableTitle} />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CngCrudTable
              {...props}
              fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
              addRoute={`${pathname}/add`}
              columns={columns}
              del={{ url: DbAdminStatusConfigApiUrls.DELETE }}
              editRoute={`${pathname}/edit`}
              exportData={{ url: DbAdminStatusConfigApiUrls.EXPORT }}
              fetch={{ url: DbAdminStatusConfigApiUrls.GET }}
              idAccessor="id"
              notification={notification}
              //tableConfigurationCode="REPLACE_WITH_CORE_TABLE_CONFIG_CODE"
              viewRoute={`${pathname}/view`}
              options={{
                pageSize: 10,
                pageSizeOptions: [10, 20, 50, 100, 500, 1000]
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default TablePage
